module.exports = __webpack_public_path__ + "img/3_1.38920f03.png";